import React from 'react';
import '../styles/Global.css'; // Shared CSS file for consistent styling
import '../styles/ContactUs.css'; // Specific styles for ContactUs page

import Header from './Header';
import Footer from './Footer';

const ContactUs: React.FC = () => (
        <div className="page-container">
            <Header />
            <main className="page-content">
                <section className="contact-section">
                    <h1>Contact Us</h1>
                    <p>We’d love to hear from you! Fill out the form below and let’s start a conversation.</p>
                    <form className="contact-form">
                        <div className="form-group">
                            <label htmlFor="name">Name:</label>
                            <input type="text" id="name" name="name" placeholder="Enter your name" required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">Email:</label>
                            <input type="email" id="email" name="email" placeholder="Enter your email" required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="message">Message:</label>
                            <textarea id="message" name="message" placeholder="Enter your message" required></textarea>
                        </div>
                        <button type="submit" className="submit-button">
                            <span>Let’s Talk</span>
                        </button>
                    </form>
                </section>
            </main>
            <Footer />
        </div>
    );

export default ContactUs;